const TicketFormatService = function (Config) {
  return {
    /**
     * @var {TicketFormat[]}
     */
    formats: [],

    /**
     * @param {TicketFormat[]} formats
     * @returns {TicketFormatService}
     */
    setFormats: function (formats) {
      this.formats = formats;
      return this;
    },

    getFromConfig: function (id) {
      var ticketFormat = null;

      if (!id) {
        return ticketFormat;
      }

      for (var index in this.formats) {
        var ticketFormatForId = false;
        this.formats[ index ].ticketformats.forEach(function (element) {
            if (parseInt(element) === parseInt(id)) {
            ticketFormatForId = element;
          }
        });
        if (this.formats.hasOwnProperty(index) && this.formats[ index ].ticketformats && ticketFormatForId) {
          ticketFormat = this.formats[ index ];
          break;
        }
      }

      return ticketFormat;
    },

    /**
     * @returns {null|TicketFormat}
     */
    getDefaultFormatByConfig: function () {
      var format = null;
      for (var index in this.formats) {
        if (!this.formats.hasOwnProperty(index)) {
          continue;
        }

        var defaultTicketFormatId = Config.default_ticketformat_checkout;

        if (defaultTicketFormatId !== false) {
          var defaultTicketFormat = false;
          this.formats[ index ].ticketformats.forEach(function (element) {
            if (parseInt(element) === parseInt(defaultTicketFormatId)) {
              defaultTicketFormat = element;
            }
          });

          if (this.formats.hasOwnProperty(index) &&
            this.formats[ index ].ticketformats &&
            defaultTicketFormat) {
            format = this.formats[ index ];
          }
        } else if (this.formats[ index ].identifier === "color") {
          format = this.formats[ index ];
        }
      }
      return format;
    },

    validate: function (format) {
      if (!format || !format.id) {
        return false;
      }

      for (var key in this.formats) {
        if (!this.formats.hasOwnProperty(key)) {
          continue;
        }

        if (parseInt(this.formats[ key ].id) === parseInt(format.id)) {
          return true;
        }
      }
      return false;
    }
  };
};

export default TicketFormatService;


